export const mutations = {
  mutationsAddCount(state, n = 0) {
    return (state.count += n);
  },
  mutationsReduceCount(state, n = 0) {
    return (state.count -= n);
  },
  mutationsGetUserinfo(state, userinfo) {
    state.username = userinfo.user.username;
    state.userInfos = userinfo.user;
    state.authInfos = userinfo.auth;
    window.localStorage.setItem("userInfo", JSON.stringify(userinfo));
    state.strictCtrlInfo = userinfo;  // 新增独立数据 strictCtrlInfo
  },
  mutationsGetUserRouter(state, userinfo) {
    state.routerList = userinfo.list;
  }
};



// WEBPACK FOOTER //
// ./src/vuex/mutations.js